import React from 'react';
import './Home.css';

function Greeting() {
  return (
    <section className="greeting">
      <h3>Hello and Welcome!</h3>
      <p>
        I am on a journey to collaborate with designers and engineers to bring
        well designed user interfaces to life. Creating solutions and
        manipulating code to bring a vision from dream to reality is a creative
        process that brings me joy!
      </p>
      <p>
        My latest project, Fingerpaint, began as a hackathon for Mintbean but
        quickly turned into full React passion project. Built for mobile,
        Fingerpaint is a preliterate paint app for kids! Check it out below.
      </p>
      <p>Follow me on LinkedIn for project updates.</p>
    </section>
  );
}

export default Greeting;
